import { SearchMode } from "../models/interfaces";

// The search depth (fast / medium / high) in a shared link. Its own key: it is
// not a filter, and a depth-only link must not make useFilterSync skip its
// filter restore. Not `mode`: preact-router hands every query param to the
// router as a match, and `matches.mode` is dispatched as the widget/portal
// appearance mode.
//
// Its own module, not useFilterDeepLink: the search slice reads it for its
// initial state, and that hook imports the slice.
export const MODE_KEY = "depth";
const SEARCH_MODES: SearchMode[] = ["fast", "medium", "high"];

/**
 * The depth a shared link asks for, or null when it carries none (or junk).
 * SearchModeSelector checks this so its per-portal restore does not overwrite
 * the link's choice.
 */
export const searchModeFromUrl = (): SearchMode | null => {
  try {
    const raw = new URLSearchParams(window.location.search).get(MODE_KEY);
    return SEARCH_MODES.includes(raw as SearchMode)
      ? (raw as SearchMode)
      : null;
  } catch {
    return null;
  }
};
